import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import ExternalPartners from '../components/ExternalPartners';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import TestimonialsSection from '../components/TestimonialsSection';
import CalendlySection from '../components/CalendlySection';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';

const LandingPage = () => {
  const location = useLocation();
  usePageMeta();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    const t = setTimeout(() => {
      const el = document.getElementById(target);
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
    }, 150);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <About />
      <ExternalPartners />
      <Services />
      <WhyChooseUs />
      <TestimonialsSection />
      <CalendlySection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default LandingPage;
